import {
  CheckItemResponse,
  ChecklistItemModel,
  ChecklistModel,
  ChecklistResponse,
} from 'types';
import genericNormalizer from './generic';

export const normalizeChecklistItem = genericNormalizer<
  CheckItemResponse,
  ChecklistItemModel
>(({ from, has }) => ({
  checked: has('state', (state) => state === 'complete'),
  id: from('id'),
  name: from('name'),
  nameData: from('nameData'),
  pos: from('pos'),
}));

export const normalizeChecklist = genericNormalizer<
  ChecklistResponse,
  ChecklistModel
>(({ from, has }) => ({
  id: from('id'),
  idBoard: from('idBoard'),
  idCard: from('idCard'),
  checkItems: has('checkItems', (checkItems) =>
    // We always get back the full checkItem, so we don't need to merge it
    checkItems.map((checkItem) => normalizeChecklistItem(checkItem)),
  ),
  name: from('name'),
  pos: from('pos'),
}));



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/checklist.ts